import { useSuspenseQuery } from "@tanstack/react-query";
import { getMailAddress } from "../openapi/api-client";
import { GetEmailAddressError } from "../errors/GetEmailAddressError";

export const useMailAddress = (mailAddressId: string) => {
  return useSuspenseQuery({
    queryKey: ["mailAddress", mailAddressId],
    queryFn: async () => {
      const response = await getMailAddress({
        path: { mailAddressId },
      });

      if (!response.data) {
        throw new GetEmailAddressError(
          `error while getting email address: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
};
